import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import { CRM_BREAK_POINT, CRM_COLLAPSED_WIDTH } from '../../crm-sidebar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CrmHeader = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  flexDirection: "row",
  alignItems: "center",
  blockSize: "116px",
  padding: "600",
  borderBlockEndWidth: "100",
  borderBlockEndStyle: "solid",
  borderBlockEndColor: "border-core-subtle",
  children: children
});
CrmHeader.displayName = 'CrmHeader';
const CollapsedCard = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  inlineSize: "100%",
  minBlockSize: "55px",
  maxBlockSize: "55px",
  paddingInlineStart: "300",
  paddingInlineEnd: "300",
  borderBlockEndWidth: "100",
  borderBlockEndStyle: "solid",
  borderBlockEndColor: "border-core-subtle",
  children: children
});
CollapsedCard.displayName = 'CollapsedCard';
const CollapsedWrapper = styled.div.withConfig({
  displayName: "ContactSidebarPlaceholder__CollapsedWrapper",
  componentId: "m8eul1-0"
})(["@media (min-width:", "px){display:none;}"], CRM_BREAK_POINT);
const FullWrapper = styled.div.withConfig({
  displayName: "ContactSidebarPlaceholder__FullWrapper",
  componentId: "m8eul1-1"
})(["@media (max-width:", "px){display:none;}"], CRM_BREAK_POINT);
export default class ContactSidebarPlaceholder extends PureComponent {
  renderCollapsed() {
    return /*#__PURE__*/_jsx(CollapsedWrapper, {
      children: /*#__PURE__*/_jsxs(Flex, {
        inlineSize: `${CRM_COLLAPSED_WIDTH}px`,
        "data-test-id": "contact-sidebar-placeholder-collapsed",
        flexDirection: "column",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(SkeletonView, {
          blockSize: "1.5em",
          inlineSize: "1.5em",
          marginBlockStart: "400",
          marginInline: "auto"
        }), /*#__PURE__*/_jsx(SkeletonCircle, {
          size: 32,
          marginBlockStart: "600",
          marginInline: "auto"
        })]
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderCollapsed(), /*#__PURE__*/_jsx(FullWrapper, {
        children: /*#__PURE__*/_jsxs(Flex, {
          "data-test-id": "contact-sidebar-placeholder",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsxs(CrmHeader, {
            children: [/*#__PURE__*/_jsx(SkeletonCircle, {
              size: 48,
              marginInlineEnd: "300"
            }), /*#__PURE__*/_jsxs(View, {
              children: [/*#__PURE__*/_jsx(SkeletonText, {
                inlineSize: "100px"
              }), /*#__PURE__*/_jsx(SkeletonText, {
                inlineSize: "140px"
              })]
            })]
          }), /*#__PURE__*/_jsx(CollapsedCard, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "90%"
            })
          }), /*#__PURE__*/_jsx(CollapsedCard, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "70%"
            })
          }), /*#__PURE__*/_jsx(CollapsedCard, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "60%"
            })
          }), /*#__PURE__*/_jsx(CollapsedCard, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "80%"
            })
          }), /*#__PURE__*/_jsx(CollapsedCard, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "60%"
            })
          })]
        })
      })]
    });
  }
}
ContactSidebarPlaceholder.displayName = 'ContactSidebarPlaceholder';